import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AccountService, EMAIL_PASSWORD_OPTION, LOGIN_OPTION_PARAM } from '@app/_services/account.service';

/**
 * Guard that handles login redirects from query parameters.
 * This prevents the login component from fully loading before redirecting to the OAuth flow.
 */
export const LoginRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const accountService = inject(AccountService);

  const loginOption = route.queryParams[LOGIN_OPTION_PARAM];

  if (loginOption) {
    const normalizedOption = loginOption.toLowerCase();
    if (normalizedOption === EMAIL_PASSWORD_OPTION.toLowerCase()) {
      accountService.initLoginFlow();
    } else {
      accountService.loginWithIdp(normalizedOption);
    }
    return false;
  }
  return true;
};
